import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';

// UTILS
import { useQuery } from '../../util/hooks';

// REDUX AND SLICES
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { loginApplicant } from '../../reducers/auth-slice';
import { fetchCheckoutAttributes } from '../../reducers/checkout-slice';

// WEB COMPONENTS
import { Button, IconLogo } from '@payright/web-components';

// OTHER COMPONENTS
import { ControlledInputField } from '../../components/form-fields';
import SCSpinner from '../../components/spinner';

// STYLES AND STYLED COMPONENTS
import SCEcommerceLogin from './css';
import { AppThunkDispatch } from '../../util/store';

interface LoginApplicantProps {}

type FormData = {
  code: string;
};

const LoginApplicant = (props: LoginApplicantProps) => {
  const history = useHistory();
  const dispatch = useDispatch<AppThunkDispatch>();

  // URL QUERY PARAMS
  const query = useQuery();
  const queryParamCheckoutId = query.get('checkoutId');

  // GLOBAL STATE
  const globalAuthState = useSelector((state: RootState) => state.auth);
  const globalCheckoutState = useSelector((state: RootState) => state.checkout);

  // VARIABLES
  const { errorMessage, isLoggedIn, loading } = globalAuthState;
  const planId = globalCheckoutState.checkout?.planId || '';
  const checkoutType = globalCheckoutState.checkout?.attributes?.type;
  const status = globalCheckoutState.checkout?.status;

  // START LOGIN FORM
  const reactHookForm = useForm<FormData>({
    defaultValues: {
      code: '',
    },
    mode: 'onChange',
  });
  const { handleSubmit, formState } = reactHookForm;

  const formSubmitHandler = (formData: FormData) => {
    dispatch(loginApplicant(planId, formData.code));
  };
  // END LOGIN FORM

  // LOAD LATEST CHECKOUT FROM THE SERVER
  useEffect(() => {
    if (queryParamCheckoutId) {
      dispatch(fetchCheckoutAttributes(queryParamCheckoutId));
    }
  }, [queryParamCheckoutId, dispatch]);

  return (
    <SCEcommerceLogin>
      <div className="ecommerce-image" />
      <div className="login-wrapper">
        <div className="login-header">
          <div className="logo">
            <IconLogo width={180} height={74} />
          </div>
          <h4>Login</h4>
        </div>
        <FormProvider {...reactHookForm}>
          <form onSubmit={handleSubmit(formSubmitHandler)} className="loginForm">
            <div data-testid="error-message">
              {errorMessage && (
                <div className="validation-msg-box">Incorrect verification code</div>
              )}
            </div>
            <ControlledInputField
              placeholder="Enter code"
              name="code"
              type="password"
              rules={{ required: true }}
            >
              Verification code
            </ControlledInputField>
            <Button
              withShadow
              disabled={formState.isValid === false || loading}
              maxWidth="100%"
              type="submit"
              iconPosition="right"
              icon={loading ? <SCSpinner /> : undefined}
            >
              Login
            </Button>
          </form>
        </FormProvider>
      </div>
    </SCEcommerceLogin>
  );
};

export default LoginApplicant;
